import { Helmet } from "react-helmet-async";
import { useSettings } from "@/context/SettingsContext";

export function Seo({ title, description, image, canonical, robots, jsonLd, type = "website" }) {
  const { settings } = useSettings();
  const seo = settings?.seo || {};
  const t = title || seo.title || settings?.site_title || "TakipciSatis.com";
  const d = description || seo.description || settings?.site_description || "";
  const img = image || seo.og_image || "/takipcisatis-logo.png";
  const rob = robots || seo.robots || "index,follow";
  return (
    <Helmet>
      <html lang="tr" />
      <title>{t}</title>
      <meta name="description" content={d} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      <meta name="robots" content={rob} />
      {canonical && <link rel="canonical" href={canonical} />}
      {settings?.google_verification && <meta name="google-site-verification" content={settings.google_verification} />}
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
